module.exports = __webpack_public_path__ + "static/media/dot_loader.c248cc5e.gif";